import { render, staticRenderFns } from "./DowloadTemplate.vue?vue&type=template&id=a94dcf9e&scoped=true&"
import script from "./DowloadTemplate.vue?vue&type=script&lang=js&"
export * from "./DowloadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DowloadTemplate.vue?vue&type=style&index=0&id=a94dcf9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94dcf9e",
  null
  
)

export default component.exports